module.exports = __webpack_public_path__ + "static/media/empty.584ea52a.svg";